module.exports = __webpack_public_path__ + "media/icons/heart_filled-1ed54c99.png";